import React from "react";
import { Helmet } from "react-helmet";
import { Button, Form, notification, Select, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import cookie from "react-cookies";
import axios from "axios";
import { useEffect, useState } from "react";

const EditContact = () => {
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(true);
  const [editData, setEditData] = useState({});

  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };
  const navigate = useNavigate();
  const params = useParams();
  const getContactHandler = () => {
    setLoader2(true);
    const token = cookie.load("token");
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    axios
      .get(
        `${process.env.REACT_APP_FRONTED_URL}/contact-us-requests/${params?.id}?locale=en`,
        config
      )
      .then((response) => {
        setEditData(response?.data?.data);
        setLoader2(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader2(false);
      });
  };
  useEffect(() => {
    getContactHandler();
    // eslint-disable-next-line
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    setLoader(true);
    const token = cookie.load("token");
    const payload = {
      status: values.status,
    };
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    if (values.status === "Open") {
      openNotification(
        "Warning",
        "You have to update the status to 'In Progress' or to 'Closed'"
      );
      setLoader(false);
    } else {
      axios
        .post(
          `${process.env.REACT_APP_FRONTED_URL}/update-status/${params?.id}?_method=PUT&locale=en`,
          payload,
          config
        )
        .then(() => {
          navigate("/contact");
          setLoader(false);
          openNotification("Success", "Contact Status Updated Successfully");
        })
        .catch((error) => {
          setLoader(false);
          openNotification("Error", "");
        });
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>4EVERINLOVE - EDIT CONTACT STATUS</title>
        <meta name="description" content="4everinlove Edit Contact Status" />
      </Helmet>
      <div className="header">
        <h3>Edit Contact Status</h3>
      </div>
      {loader2 ? (
        <div className="event_spin">
          <Spin />
        </div>
      ) : (
        <div className="form_container">
          <Form
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              status: editData?.status,
            }}
          >
            <Form.Item
              name="status"
              label="Status"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                options={[
                  { value: "Open", label: "Open" },
                  {
                    value: "In progress",
                    label: "In progress",
                  },
                  {
                    value: "Closed",
                    label: "Closed",
                  },
                ]}
              />
            </Form.Item>
            <Form.Item>
              <div className="form_submit">
                <Button
                  className="back_button"
                  onClick={() => navigate("/contact")}
                >
                  Cancel
                </Button>
                <Button htmlType="submit">{loader ? "...wait" : "save"}</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      )}
    </React.Fragment>
  );
};
export default EditContact;
